import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/houston")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Awnings in Houston | Commercial & Residential Awnings, Sail Shades & Patio Covers Houston, TX | Texas Made Shade",
      description: "Awnings in Houston, sail shades Houston, commercial & residential awnings, patio & pergola covers.",
      keywords: "awnings in Houston, awning company Houston, commercial awnings Houston, residential awnings Houston, sail shades Houston, patio covers Houston, pergola covers Houston, custom pergola covers Houston, aluminum pergola covers Houston, metal awnings Houston, canvas awnings Houston, marine canvas Houston, Texas Made Shade",
      image: hero,
      socialTitle: "Awnings in Houston, Sail Shades & Patio Covers — Texas Made Shade",
      socialDescription: "Awnings in Houston + sail shades Houston. Welded aluminum + Sunbrella canvas, built in Seguin and installed across Harris County.",
    }),
    scripts: cityHeadScripts("Houston", "Harris County"),
  }),
  component: () => <CityHomePage city="Houston" region="Harris County" />,
});
